import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-radial-progress',
  templateUrl: './radial-progress.component.html',
  styleUrls: ['./radial-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class RadialProgressComponent implements OnInit {
  @Input() stepsCount: number;
  @Input() currentStepIndex: number;

  public readonly radius = 45;
  public readonly strokeWidth = 8;
  private percentIncrement: number;

  ngOnInit(): void {
    this.percentIncrement = 100 / this.stepsCount;
  }

  get percentProgress(): number {
    return this.currentStepIndex * this.percentIncrement;
  }

  get normalizedRadius(): number {
    const spaceForShadow = 2;
    return this.radius - ((this.strokeWidth / 2) + spaceForShadow);
  }

  get circumference(): number {
    return this.normalizedRadius * 2 * Math.PI;
  }

  get completedStepsStrokeDashoffset(): number {
    if (this.percentProgress === 0) { return 0 }
    return this.circumference - (this.percentProgress - this.percentIncrement) / 100 * this.circumference;
  }

  get strokeDashoffset(): number {
    return this.circumference - this.percentProgress / 100 * this.circumference;
  }
}
